module.exports = __webpack_public_path__ + "img/speaker.280d8954.svg";